import { TabPanel, TabPanels, useToast } from '@chakra-ui/react';
import React from 'react';
import { Formik } from 'formik';
import { localise } from '../../../../services/lang/lang';
import useGenericMutationUseCase from '../../../../hooks/usecases/generic/useGenericMutationUseCase';
import { useUpdateLocation } from '../../../../services/api/generated/client';
import LocationNotesWrapper from '../../Notes/LocationNotesWrapper';
import EditLocationFormWrapper from './EditLocationFormWrapper';
import { useInspectionDetailContext } from '../../../pages/upgrade/InspectionDetail/InspectionDetailProvider';
import EditLocationFormShareWrapper from './Share/EditLocationFormShareWrapper';
import LocationNotesShareWrapper from '../../Notes/Share/LocationNotesShareWrapper';
import ModalWithSidebar from '../../Modal/ModalWithSidebar';
import SuspenseWrapper from '../../SuspenseWrapper/SuspenseWrapper';
import { useUnsavedChanges } from '../../UnsavedChanges/UnsavedChangesProvider';
import PhotosWrapper from '../../Photos/PhotosWrapper';
const EditLocationModal = (props) => {
    const { isShare } = useInspectionDetailContext();
    const { attemptNavigate } = useUnsavedChanges();
    const updateLocation = useGenericMutationUseCase(useUpdateLocation);
    const toast = useToast();
    const initialValues = {
        name: props.location.name,
        dimensions: props.location.dimensions,
        floor_number: props.location.floor_number,
        room_positions: props.location.room_positions,
    };
    const onSubmit = (values, helpers) => {
        updateLocation.execute({
            locationId: props.location.id,
            data: {
                ...values,
                room_positions: values.room_positions.map((r) => r.id),
            },
        }, helpers, {
            onSuccess: () => {
                toast({
                    title: localise('LOCATION_UPDATED'),
                    status: 'success',
                    isClosable: true,
                });
                props.onSuccess();
            },
        });
    };
    const LocationComponent = isShare
        ? EditLocationFormShareWrapper
        : EditLocationFormWrapper;
    const LocationNotesComponent = isShare
        ? LocationNotesShareWrapper
        : LocationNotesWrapper;
    return (React.createElement(ModalWithSidebar, { tabTitles: [localise('DETAILS'), localise('NOTES'), localise('PHOTOS')], onClose: props.onClose, title: props.canEdit
            ? localise('EDIT_LOCATION_DETAILS')
            : localise('LOCATION_DETAILS'), isOpen: props.isOpen, verifyOnBlur: attemptNavigate, isFullWidth: true },
        React.createElement(TabPanels, null,
            React.createElement(TabPanel, null,
                React.createElement(SuspenseWrapper, null,
                    React.createElement(Formik, { initialValues: initialValues, onSubmit: onSubmit },
                        React.createElement(LocationComponent, { canEdit: props.canEdit, onClose: props.onClose })))),
            React.createElement(TabPanel, null,
                React.createElement(SuspenseWrapper, null,
                    React.createElement(LocationNotesComponent, { canEdit: props.canEdit, model: props.location }))),
            React.createElement(TabPanel, null,
                React.createElement(PhotosWrapper, { isShare: isShare, onPhotosMutated: props.onLocationMutated, photos: props.location.photos, canEdit: props.canEdit, model: props.location, type: "location" })))));
};
export default EditLocationModal;
